import { Disclosure } from "@headlessui/react";
import { Link } from "react-router-dom";
import React, { useState } from "react";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { useLocation } from "react-router-dom";
import { LeasedEquipmentTabs } from "./UtilityLeasedEquipmentTabs";
const Submenu = ({ item }) => {
  const userPermissions = useRecoilValue(permissionsSelector);
  const { pathname } = useLocation();
  const [hover, setHover] = useState();
  const index1 = LeasedEquipmentTabs.findIndex((item) => pathname === item.to);
  return (
    <div>
      <div className="pl-4 py-4 rounded-l-lg bg-quinary">
        {LeasedEquipmentTabs.map(
          (item, index) =>
            userPermissions.includes(item.permission) && (
              <Link
                onMouseEnter={() => setHover(index)}
                onMouseLeave={() => setHover(undefined)}
                className={
                  item.to === pathname
                    ? "bg-white rounded-l-lg text-secondary flex items-center font-medium p-2 sidebar-text-size"
                    : `flex items-center text-white bg-quinary sidebar-text-size
                    ${hover === index ||
                      index === hover - 1 ||
                      index === 4 ||
                      index1 === index + 1
                      ? "rounded-l-lg"
                      : "border-b border-septenary border-opacity-25"
                    } hover:bg-secondary p-2 sidebar-text-size`
                }
                to={item.to}
                key={index}
              >
                {item.title}
              </Link>
            )
        )}
      </div>
    </div>
  );
};
export default Submenu;
